import React, { FC, useState } from "react";

import { Stack } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { DownloadIcon } from "@assets/icons";

import { BatchDownloadModal, File } from "./BatchDownloadModal";

import styles from "./BatchDownloadModal.module.scss";

interface DownloadsButtonProps {
  files: File[];
}

export const DownloadsButton: FC<DownloadsButtonProps> = ({ files }) => {
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const isDisabled = files.length === 0;

  return (
    <>
      <div
        className={classNames(styles["download-link"], { [styles["disabled"]]: isDisabled })}
        onClick={(e) => {
          e.stopPropagation();
          if (!isDisabled) {
            setShowDownloadModal(true);
          }
        }}
        role="button"
        aria-disabled={isDisabled}
      >
        <Stack direction="horizontal" gap={2}>
          <ReactSVG src={DownloadIcon} className={styles["download-icon"]} />
          <span className={`b3 bold ${isDisabled ? styles["disabled-text"] : ""}`}>Downloads</span>
        </Stack>
      </div>
      <BatchDownloadModal show={showDownloadModal} onHide={() => setShowDownloadModal(false)} files={files} />
    </>
  );
};
